var app = {};

app.init = () => {
	if (document.querySelector('.js-nav-trigger')) {
		app.common.nav();
	}
	if (document.querySelector('.js-search-trigger')) {
		app.common.search();
	}
	if (document.querySelector('.js-accordion')) {
		app.common.accordion();
	}
	if (document.querySelector('.js-information-carousel')) {
		app.common.information();
	}
	if (document.querySelector('a[href^="#"]')) {
		app.common.smoothScroll();
	}
      if (document.querySelector('.p-page-header')) {
		app.common.modeChage();
	}
	if (document.querySelector('.js-home-visual')) {
		app.home.headerFixed();
		app.home.visual();
	}
	if (document.querySelector('.js-home-visual-video')) {
		app.home.visualVideo();
	}
	if (document.querySelector('.js-home-new-carousel')) {
		app.home.newArrival();
	}
	if (document.querySelector('.js-home-lookbook-main')) {
		app.home.lookbook();
	}
	if (document.querySelector('.js-item-carousel')) {
		app.itemList.itemCarousel();
	}
	if (document.querySelector('.js-insert-target') && document.querySelector('.js-insert-source')) {
		app.itemList.itemInsert();
	}
	if (document.querySelector('.js-item-detail-carousel')) {
		app.itemDetail.itemImageCarousel();
	}
	if (document.querySelector('.js-item-detail-columns') && document.querySelector('.js-item-detail-columns__sticky-column')) {
		app.itemDetail.columns();
	}
	if (document.querySelector('.js-recommend-carousel')) {
		app.itemDetail.recommendCarousel();
	}
	if (document.querySelector('.js-topics-items')) {
		app.topics.topicsItems();
	}
};

app.common = {
	nav: () => {
		const nav = document.querySelector('.p-nav');
		const fixedHeader = document.querySelector('.p-fixed-header');
		const navTrigger = document.querySelector('.js-nav-trigger');
		const fixedNavTrigger = document.querySelector('.js-fexed-nav-trigger');
		const fixedNavText = document.querySelector('.p-fixed-header-trigger__text');
		const navItems = document.querySelectorAll('.js-nav-trigger-content');
		const categoryItems = document.querySelectorAll('.js-nav-trigger-category');
		const backButtons = document.querySelectorAll('.js-nav-back');
		const navContents = document.querySelectorAll('.p-nav-content');
		const categoryContents = document.querySelectorAll('.p-nav-category');
		const closeButton = document.querySelector('.js-nav-close');
		const openClass = 'is-open';
		const openTimeline = gsap.timeline({ paused: true });
		const closeTimeline = gsap.timeline({ paused: true });

		openTimeline
		.add(() => {
			nav.classList.add(openClass);
			document.body.classList.add(openClass);
			fixedHeader.classList.add(openClass);
			fixedNavText.textContent = '閉じる';

			const overlay = document.createElement('div');
			overlay.className = 'p-overlay';
			// document.body.prepend(overlay);
            const headerSticky = document.querySelector('.shopify-section-header-sticky');
            if (headerSticky) {
              headerSticky.prepend(overlay);
            }

			overlay.addEventListener('click', () => closeTimeline.restart());
		})
		.to('.p-fixed-header', {
			width: 'calc(110 / 390 * 100vw)',
			duration: 0.3,
			zIndex: 2000,
			ease: 'power1.out',
		})

		closeTimeline
		.to('.p-fixed-header', {
			width: 'calc(290 / 390 * 100vw)',
			duration: 0.3,
			zIndex: 20,
			ease: 'power1.out',
		})
		.add(() => {
			nav.classList.remove(openClass);
			document.body.classList.remove(openClass);
			fixedHeader.classList.remove(openClass);
			fixedNavText.textContent = 'メニュー';

			const overlay = document.querySelector('.p-overlay');
			if (overlay) overlay.remove();
		});

		let isNavOpen = false;
		fixedNavTrigger.addEventListener('click', () => {
			if (isNavOpen) {
				closeTimeline.restart();
			} else {
				openTimeline.restart();
			}
			isNavOpen = !isNavOpen;
		});

		navTrigger.addEventListener('click', () => {
			nav.classList.add(openClass);
			document.body.classList.add(openClass);

			const overlay = document.createElement('div');
			overlay.className = 'p-overlay';
			// document.body.prepend(overlay);
            const headerSticky = document.querySelector('.shopify-section-header-sticky');
            if (headerSticky) {
              headerSticky.prepend(overlay);
            }

			overlay.addEventListener('click', () => {
				nav.classList.remove(openClass);
				document.body.classList.remove(openClass);
				navContents.forEach((nav) => nav.classList.remove(openClass));
				categoryContents.forEach((cat) => cat.classList.remove(openClass));
				nav.style.overflow = '';
				overlay.remove();
			});
		});

		closeButton.addEventListener('click', () => {
			nav.classList.remove(openClass);
			document.body.classList.remove(openClass);
			navContents.forEach((nav) => nav.classList.remove(openClass));
			categoryContents.forEach((cat) => cat.classList.remove(openClass));
			nav.style.overflow = '';

			const overlay = document.querySelector('.p-overlay');
			if (overlay) overlay.remove();
		});

		navItems.forEach(item => {
			const targetNav = item.getAttribute('data-nav');
			const targetElement = document.getElementById(targetNav);

			item.addEventListener('click', () => {
				navContents.forEach(nav => nav.classList.remove(openClass));

				if (targetElement) {
					targetElement.classList.add(openClass);
				}
				nav.style.overflow = 'hidden';
			});
		});

		categoryItems.forEach(item => {
			const targetNav = item.getAttribute('data-nav');
			const targetElement = document.getElementById(targetNav);

			item.addEventListener('click', () => {
				categoryContents.forEach(cat => cat.classList.remove(openClass));
				if (targetElement) {
					targetElement.classList.add(openClass);
				}
			});
		});

		backButtons.forEach(button => {
			button.addEventListener('click', () => {
				const parentContent = button.closest('.is-open');
				if (parentContent) {
					parentContent.classList.remove(openClass);
				}
				nav.style.overflow = '';
			});
		});
	},

  search: () => {
    const search = document.querySelector('.p-header-search');
    const triggers = document.querySelectorAll('.js-search-trigger, .js-fixed-search-trigger');
    const closeSearchButton = document.querySelector('.js-search-close');
    const openClass = 'is-open';
  
    triggers.forEach(trigger => {
      trigger.addEventListener('click', () => {
        search.classList.add(openClass);
        document.body.classList.add(openClass);
        const overlay = document.createElement('div');
        overlay.className = 'p-overlay';
        // document.body.prepend(overlay);
        const headerSticky = document.querySelector('.shopify-section-header-sticky');
        if (headerSticky) {
          headerSticky.prepend(overlay);
        }
  
        overlay.addEventListener('click', () => {
          search.classList.remove(openClass);
          document.body.classList.remove(openClass);
          search.style.overflow = '';
          overlay.remove();
        });
      });
    });
  
    closeSearchButton.addEventListener('click', () => {
      search.classList.remove(openClass);
      document.body.classList.remove(openClass);
      search.style.overflow = '';
  
      document.querySelector('.p-overlay').remove();
    });
  },
  
  accordion: () => {
		let resizeTimeout;

		// 初期状態の設定
		document.querySelectorAll('.js-accordion').forEach(container => {
			const trigger = container.querySelector('.js-accordion__trigger');
			const content = container.querySelector('.js-accordion__content');
			const isOpen = content.classList.contains('is-open'); // 初期状態でis-openがあるか確認

			// 初期状態のスタイル設定
			requestAnimationFrame(() => {
				if (isOpen) {
					// 開いておく
					content.style.maxHeight = 'max-content';
					content.style.overflow = 'hidden';
					trigger.classList.add('is-open');
				} else {
					// 閉じる
					content.style.maxHeight = 0;
					content.style.overflow = 'hidden';
				}
			});

			// トリガーのクリックイベント
			trigger.addEventListener('click', function () {
				const openClass = 'is-open';
				const footerAccordion = container.classList.contains('p-footer-nav');
				const hasOpen = content.classList.contains(openClass);

				if (footerAccordion && !hasOpen) {
					// 他のアコーディオンを閉じる
					document.querySelectorAll('.p-footer-nav .js-accordion__content.is-open').forEach(openContent => {
						gsap.to(openContent, { maxHeight: 0, duration: 0.5 });
						openContent.classList.remove(openClass);
						openContent.previousElementSibling.classList.remove(openClass);
					});
				}

				if (hasOpen) {
					// アコーディオンを閉じる
					content.style.maxHeight = content.scrollHeight + "px";
					gsap.to(content, { maxHeight: 0, duration: 0.5 });
					content.classList.remove(openClass);
					this.classList.remove(openClass);
				} else {
					// アコーディオンを開く
					gsap.to(content, {
						maxHeight: content.scrollHeight + "px",
						duration: 0.5,
						onComplete: () => {
							content.style.maxHeight = 'max-content';
						}
					});
					content.classList.add(openClass);
					this.classList.add(openClass);
				}
			});
		});

		// リサイズ時の処理
		window.addEventListener('resize', () => {
			if (resizeTimeout) {
				clearTimeout(resizeTimeout);
			}

			resizeTimeout = setTimeout(() => {
				document.querySelectorAll('.js-accordion__content.is-open').forEach(content => {
					// 高さを再計算
					gsap.set(content, { maxHeight: content.scrollHeight + "px" });
				});
			}, 200);
		});
	},

	information: () => {
		const topics = document.querySelector('.js-header-topics-container');
		const closeButton = document.querySelector('.js-header-topics-close');

		if (closeButton) {
			closeButton.addEventListener('click', () => {
				gsap.to(topics, {
					height: 0,
					opacity: 0,
					duration: 0.5,
					ease: "power2.inOut",
					onComplete: () => {
						topics.remove();
					}
				});
			});
		}

		new Splide('.js-information-carousel', {
			type   : 'loop',
			speed: 1000,
			autoplay: true,
			interval: 3000,
			pauseOnHover: false,
			arrows: false,
			pagination: false,
		}).mount();
	},
  
	smoothScroll: () => {
		document.querySelectorAll('a[href^="#"]').forEach(anchor => {
			anchor.addEventListener('click', function(e) {
				const href = this.getAttribute('href');
				if (href === '#' || href === '') return;

				const targetId = href.replace('#', '');
				const target = document.getElementById(targetId);
				if (!target) return;

				e.preventDefault();

				const header = document.querySelector('.l-header');
				const headerHeight = header ? header.offsetHeight : 0;
				const targetY = target.getBoundingClientRect().top + window.scrollY - headerHeight;

				window.scrollTo({
					top: targetY,
					behavior: 'smooth'
				});
			});
		});
	},
    modeChage: () => {
        const isLightStr = document.getElementById('light-mode').value;// 明るいテーマの場合はtrue、暗いテーマの場合はfalse
        const isLight = ( isLightStr === 'false' ) ? false:true;
    	const pageHeader = document.querySelector('.p-page-header');
    	const title = pageHeader?.querySelector('.p-page-header__title');
    	const number = pageHeader?.querySelector('.p-page-header__number');
        const search = document.querySelector('.p-item-list-search');
    	const description = pageHeader?.querySelector('.p-page-header__description');
    	const date = pageHeader?.querySelector('.p-page-header__date');
    	const checkbox = pageHeader?.querySelector('.p-item-list-checkbox__text');
    	const select = search?.querySelector('.p-item-list-search__select');
    
    	if (pageHeader) {
    		if (isLight) {
    			pageHeader.classList.add('is-light');
    			title?.classList.add('is-light');
    			number?.classList.add('is-light');
    			date?.classList.add('is-light');
    			search?.classList.add('is-light');
    			description?.classList.add('is-light');
    			checkbox?.classList.add('is-light');
    			select?.classList.add('is-light');
    		} else {
    			pageHeader.classList.remove('is-light');
    			title?.classList.remove('is-light');
    			number?.classList.remove('is-light');
    			date?.classList.remove('is-light');
    			search?.classList.remove('is-light');
    			description?.classList.remove('is-light');
    			checkbox?.classList.remove('is-light');
    			select?.classList.remove('is-light');
    		}
    
    		document.querySelectorAll('.p-page-header-category__link, .p-item-list-search__button').forEach((element) => {
    			if (isLight) {
    			  element.classList.add('is-light');
    			} else {
    			  element.classList.remove('is-light');
    			}
    		});
    	}
    }
};

app.home = {
	headerFixed: () => {
		const header = document.querySelector(".p-header-logo");
		const headerHeight = header.offsetHeight;
		const fixClass = "is-fixed";
		let isAnimating = false;

		header.classList.add("p-header-logo--home");
		requestAnimationFrame(() => {
			header.classList.add("is-initialized");
		});

		window.addEventListener("scroll", () => {
			if (isAnimating) {
				return;
			}

			if (window.scrollY > headerHeight) {
				if (!header.classList.contains(fixClass)) {
					header.classList.add(fixClass);
					isAnimating = true;
				}
			} else {
				if (header.classList.contains(fixClass)) {
					header.classList.remove(fixClass);
				}
			}

			header.addEventListener('transitionend', () => {
				isAnimating = false;
			});
		});
	},
	visual: () => {
		const visualSections = document.querySelectorAll(".js-home-visual .p-home-visual__box");
		const fixedClass = "is-fixed";
		const relativeClass = "is-relative";
		let isTicking = false;

		const setVisualState = (el, addClass, removeClass, transform = "", hidden = false) => {
			const imageEl = el.querySelector(".p-home-visual__image");
			if (!imageEl) return;

			imageEl.classList.toggle("is-hidden", hidden); // 非表示制御

			if (!imageEl.classList.contains(addClass)) {
				imageEl.classList.add(addClass);
				imageEl.classList.remove(removeClass);
				imageEl.style.transform = transform;
			}
		};

		const updateVisualStates = () => {
			const windowHeight = window.innerHeight;

			visualSections.forEach((section, index) => {
				const imageEl = section.querySelector(".p-home-visual__image");
				if (!imageEl) return;

				// 通常は section の次の兄弟要素を使う
				let nextContent = section.nextElementSibling;

				// 最後の要素なら .js-home-visual の直後要素を使う（全体の次セクション）
				if (!nextContent && index === visualSections.length - 1) {
					const wrapper = section.closest('.shopify-section');
					nextContent = wrapper?.nextElementSibling;
				}

				if (!nextContent) return;

				const sectionRect = section.getBoundingClientRect();
				const sectionTop = sectionRect.top;
				const sectionBottom = sectionRect.bottom;
				const nextTop = nextContent.getBoundingClientRect().top;
				const nextBottom = nextContent.getBoundingClientRect().bottom;

				if (nextTop <= windowHeight && nextBottom >= 0) {
					setVisualState(section, relativeClass, fixedClass, "translateY(100%)", false);
				} else if (sectionTop <= windowHeight && sectionBottom >= 0) {
					setVisualState(section, fixedClass, relativeClass, "translateY(0)", false);
				} else {
					setVisualState(section, relativeClass, fixedClass, "translateY(0)", true);
				}
			});
		};

		const updateOverlayOpacities = () => {
			const windowHeight = window.innerHeight;

			visualSections.forEach(section => {
				const imageEl = section.querySelector(".p-home-visual__image");
				if (!imageEl) return;

				const sectionTopInPage = section.getBoundingClientRect().top + window.scrollY;
				const scrollTop = window.scrollY;

				// セクションの中でのスクロール位置を取得
				const scrollInSection = scrollTop - sectionTopInPage;
				const progress = Math.min(Math.max(scrollInSection / windowHeight, 0), 1); // 0〜1に正規化
				const opacity = Math.min(progress, 0.5); // 最大0.5まで

				imageEl.style.setProperty("--overlay-opacity", opacity);
			});
		};

		const onScroll = () => {
			if (!isTicking) {
				isTicking = true;
				window.requestAnimationFrame(() => {
					updateOverlayOpacities();
					updateVisualStates();
					isTicking = false;
				});
			}
		};

		// z-indexの初期設定
		visualSections.forEach((section, index) => {
			const imageEl = section.querySelector(".p-home-visual__image");
			if (imageEl) {
				imageEl.style.zIndex = visualSections.length - index;
			}
		});

		updateOverlayOpacities();
		updateVisualStates();
		document.addEventListener("scroll", onScroll);
	},
	visualVideo: () => {
		const video = document.querySelector('.js-visual-video');
		const playButton = document.querySelector('.js-play-button');
		const volumeButton = document.querySelector('.js-volume-button');

		if (video.muted) {
			volumeButton.classList.add('is-muted');
		}

		playButton.addEventListener('click', () => {
			video.paused ? video.play() : video.pause();
			playButton.classList.toggle('is-paused', video.paused);
		});

		volumeButton.addEventListener('click', () => {
			video.muted = !video.muted;
			volumeButton.classList.toggle('is-muted', video.muted);
		});
	},
  	newArrival: () => {
		const splide = new Splide('.js-home-new-carousel', {
			type: 'loop',
			perPage: 1,
			arrows: true,
			pagination: false,
			mediaQuery: 'min',
			padding: 'calc(50 / 390 * 100vw)',
			gap: 'calc(15 / 390 * 100vw)',
			breakpoints: {
				1024: {
					perPage: 4,
					padding: 0,
					gap: 0,
				},
			},
		}).mount();
	},
	lookbook: () => {
		const mainSplide = new Splide('.js-home-lookbook-main', {
			type: 'loop',
			speed: 1000,
			focus: 'center',
			arrows: true,
			pagination: false,
			autoWidth: true,
			gap: '30px',
		}).mount();

		const yearSplide = new Splide('.js-home-lookbook-year', {
			type: 'loop',
			speed: 1000,
			autoWidth: true,
			focus: 'center',
			arrows: false,
			pagination: false,
			updateOnMove: true,
		}).mount();

		const textSwiper = new Splide('.js-home-lookbook-text', {
			type: 'loop',
			speed: 1000,
			focus: 'center',
			pagination: false,
			arrows: false,
			autoWidth: true,
			mediaQuery: 'min',
			gap: 'calc(15 / 390 * 100vw)',
			breakpoints: {
				1024: {
					perPage: 1,
					autoWidth: true,
					gap: '0'
				},
			},
		}).mount();

		mainSplide.sync(yearSplide);
		mainSplide.sync(textSwiper);

		const updatePagination = () => {
			const currentSlide = document.querySelector('.p-home-lookbook-pagination__current');
			const totalSlide = document.querySelector('.p-home-lookbook-pagination__total');

			currentSlide.textContent = mainSplide.index + 1;
			totalSlide.textContent = mainSplide.length;
		};

		mainSplide.on('mounted move', updatePagination);
		updatePagination();
	},
};

app.itemList = {
	itemCarousel: () => {
		document.querySelectorAll('.js-item-carousel').forEach(slider => {
			new Splide(slider, {
				type: 'loop',
				speed: 1000,
				pagination: false,
				drag: false,
				gap: '10px',
			}).mount();
		});
	},
  	itemInsert: () => {
		const container = document.querySelector(".js-insert-target");
		const sourceItem = document.querySelector(".js-insert-source");
		const items = Array.from(container.querySelectorAll(".p-item"));
		const require = parseInt(sourceItem.dataset.insertRequire);
		const repeat = parseInt(sourceItem.dataset.insertRepeat);
		const positionData = sourceItem.dataset.insertPosition;
		const positionsArray = positionData.split(",").map(str => parseInt(str.trim()));

		if (positionsArray.length !== repeat) {
			return;
		}

		if (items.length >= require) {
			let cumulativePositions = [];
			let total = 0;
			positionsArray.forEach(pos => {
				total += pos;
				cumulativePositions.push(total);
			});

			cumulativePositions.forEach((cumPos) => {
				// 挿入は、cumPos 番目の商品（1-indexed）の後に行うが、末尾の場合はスキップ
				if (cumPos < items.length) {
					const targetItem = items[cumPos - 1];
					const insertItem = document.createElement("li");
					insertItem.innerHTML = sourceItem.innerHTML;
					Array.from(sourceItem.attributes).forEach(attr => {
						insertItem.setAttribute(attr.name, attr.value);
					});
					insertItem.classList.add("is-show");
					if (targetItem.nextSibling) {
						container.insertBefore(insertItem, targetItem.nextSibling);
					} else {
						container.appendChild(insertItem);
					}
				}
			});
			sourceItem.remove();
		}
	},
}

app.itemDetail = {
	itemImageCarousel: () => {
		let splide;
		const mediaQuery = window.matchMedia('(max-width: 1023px)');

		function handleSplide(e) {
			const mainItems = document.querySelectorAll('.js-item-detail-carousel .splide__slide');

			// 1023px以下でSplideを有効化
			if (e.matches) {
				if (!splide) {
					splide = new Splide('.js-item-detail-carousel', {
						type: 'loop',
						speed: 1000,
						drag: true,
						focus: 'center',
						pauseOnHover: false,
						arrows: false,
						breakpoints: {
							1023: {
								gap: '20px',
								pagination: false,
							},
						},
					});

					var bar = document.querySelector('.js-item-detail-carousel .p-item-detail__progress-bar');
					// 進捗バーの更新処理
					splide.on('mounted move', function () {
						var end  = splide.Components.Controller.getEnd() + 1;
						var rate = Math.min((splide.index + 1) / end, 1);
						bar.style.width = String(100 * rate) + '%';
					});

					splide.mount();
				}
			} else {
				// 1024px以上でSplideを無効化し、paginationを表示
				if (splide) {
					splide.destroy();
					splide = null;
				}

				// paginationの追加処理
				const ProductImages = document.querySelector('.js-item-detail-carousel');
				if (ProductImages) {
					const mainItems = ProductImages.querySelectorAll('.p-item-detail__image');

					// 一番近い親要素のp-item-detail__columnsを取得
					const columnsContainer = ProductImages.closest('.p-item-detail__columns');
					let paginationContainer = columnsContainer.querySelector('.p-item-detail__pagination');

					if (!paginationContainer) {
						paginationContainer = document.createElement('div');
						paginationContainer.classList.add('p-item-detail__pagination');

						// 最初のp-item-detail__columnの前に挿入
						const firstColumn = columnsContainer.querySelector('.p-item-detail__column');
						columnsContainer.insertBefore(paginationContainer, firstColumn);
					} else {
						paginationContainer.innerHTML = '';  // 再生成時にクリア
					}

					// paginationの生成
					mainItems.forEach((item, index) => {
						const dot = document.createElement('div');
						dot.classList.add('p-item-detail__bullet');
						if (index === 0) dot.classList.add('is-active');
						dot.setAttribute('data-index', index);
						paginationContainer.appendChild(dot);
					});

					const dots = paginationContainer.querySelectorAll('.p-item-detail__bullet');

					// paginationクリック時のスクロール処理
					dots.forEach(dot => {
						dot.addEventListener('click', function () {
							const index = this.getAttribute('data-index');
							const targetItem = mainItems[index];
							const header = document.querySelector('.l-header');
							const headerHeight = header ? header.offsetHeight : 0;

							gsap.to(window, {
								scrollTo: {
									y: targetItem,
									offsetY: headerHeight
								},
								duration: 1,
								ease: 'expo.out'
							});
						});
					});


					// Intersection Observerでpaginationのアクティブ切り替え
					const observer = new IntersectionObserver(function(entries) {
						entries.forEach(entry => {
							if (entry.isIntersecting) {
								const index = Array.from(mainItems).indexOf(entry.target);
								dots.forEach(d => d.classList.remove('is-active'));
								dots[index].classList.add('is-active');
							}
						});
					}, {
						root: null,
						threshold: 0.7
					});

					// 各メイン画像を監視
					mainItems.forEach(item => {
						observer.observe(item);
					});
				}
			}
		}

		// 初回の状態をチェック
		handleSplide(mediaQuery);

		// メディアクエリの状態が変わったら関数を呼び出し
		mediaQuery.addEventListener('change', handleSplide);
	},
  
	columns: () => {

		// GSAP と ScrollTrigger のプラグイン登録
		gsap.registerPlugin(ScrollTrigger);

		// 固定表示の場合の位置更新関数（スクロールに合わせて実行）
		function updateFixedPosition() {
			const textColumn = document.querySelector('.js-item-detail-columns__sticky-column');
			const parent = document.querySelector('.js-item-detail-columns');
			if (!textColumn || !parent) return;

			const scrollY = window.scrollY;
			const columnHeight = textColumn.offsetHeight;

			// 常に position: fixed を設定
			textColumn.style.position = 'fixed';

			// 親要素の位置情報を取得し、右カラムの left を計算する
			const parentRect = parent.getBoundingClientRect();
			const newLeft = parentRect.left + parentRect.width - textColumn.offsetWidth;
			textColumn.style.left = newLeft + 'px';

			// 中央表示時の下端位置（viewport 内の値）
			const centeredBottom = window.innerHeight / 2 + columnHeight / 2;
			// 親要素の下端の viewport 内での位置
			const parentBottomViewport = parentRect.bottom;

			if (centeredBottom > parentBottomViewport) {
				// 追従要素の下端が親要素の下端に達した場合
				textColumn.style.top = (parentBottomViewport - columnHeight) + 'px';
				textColumn.style.transform = '';
			} else {
				// 通常は上下中央に固定
				textColumn.style.top = '50%';
				textColumn.style.transform = 'translateY(-50%)';
			}
		}

		// 追従処理の初期化関数
		function initSticky() {
			const textColumn = document.querySelector('.p-item-detail__column--text-column');
			const parent = document.querySelector('.p-item-detail__columns');
			if (!textColumn || !parent) return;

			// 既存のクラスをリセット
			textColumn.classList.remove('is-scrolling', 'is-centered');

			// 既存の ScrollTrigger インスタンスを全て破棄、scroll イベントも解除
			ScrollTrigger.getAll().forEach(trigger => trigger.kill());
			window.removeEventListener('scroll', updateFixedPosition);

			// インラインスタイルのリセット
			textColumn.style.position = '';
			textColumn.style.top = '';
			textColumn.style.left = '';
			textColumn.style.transform = '';
			textColumn.style.width = '';

			// 画面幅が 1280px 以上の場合のみ処理
			if (window.innerWidth >= 1280) {
				// 固定表示用に現在の幅を取得
				const rect = textColumn.getBoundingClientRect();
				textColumn.style.width = rect.width + 'px';

				if (textColumn.offsetHeight > window.innerHeight) {
					// 右カラムがウィンドウより大きい → 縦スクロール（ScrollTrigger）モード
					textColumn.classList.add('is-scrolling');

					// computed styleからmargin-topとmargin-bottomを取得
					const computedStyle = window.getComputedStyle(textColumn);
					const marginTop = parseFloat(computedStyle.marginTop) || 0;
					const marginBottom = parseFloat(computedStyle.marginBottom) || 0;
					// 右カラムの実効高さにmargin分も含める
					const effectiveHeight = textColumn.offsetHeight + marginTop + marginBottom;

					ScrollTrigger.create({
						trigger: parent,
						start: "top top",
						// endのスクロール距離は親の高さから実効高さを引いた分
						end: "+=" + (parent.offsetHeight - effectiveHeight),
						pin: textColumn,
						pinSpacing: false,
						// markers: true, // デバッグ用
					});
				} else {
					// 右カラムがウィンドウ内に収まる → 天地中央表示モード
					textColumn.classList.add('is-centered');
					updateFixedPosition();
					window.addEventListener('scroll', updateFixedPosition);
				}
			}
		}

		// 初回実行
		initSticky();

		// リサイズ時に debounce をかけて再初期化
		let resizeTimer;
		window.addEventListener('resize', function() {
			clearTimeout(resizeTimer);
			resizeTimer = setTimeout(function() {
				initSticky();
				ScrollTrigger.refresh();
			}, 200);
		});

		// 画像などの非同期要素読み込み完了後にも再計算
		window.addEventListener('load', function() {
			initSticky();
			ScrollTrigger.refresh();
		});

	},
  
	recommendCarousel: () => {

		const swiper = new Swiper('.js-recommend-carousel .swiper', {
			scrollbar: {
				el: '.swiper-scrollbar',
				draggable: true,
			},
			slidesPerView: 2,
			spaceBetween: 20,
			breakpoints: {
				768: {
					slidesPerView: 4,
					spaceBetween: 30,
				}
			}
		});

		/*
		const splide = new Splide('.js-recommend-carousel', {
			type: 'loop',
			speed: 1000,
			drag: true,
			focus: 'left',
			pauseOnHover: false,
			arrows: false,
			classes: {
				pagination: "splide__pagination recommend-carousel-pagination",
				page: "splide__pagination__page recommend-carousel-page",
			},
			focus: 0,
			omitEnd: true,
			perPage: 4,
			gap: '30px',
			breakpoints: {
				767: {
					focus: 0,
					omitEnd: true,
					perPage: 2,
					gap: '20px',
				},
			}
		});


		// 初期表示時に overflow 状態をチェックし、type を動的に切り替える
		splide.on('mounted', () => {
			updateSplideType();
		});

		// ウィンドウサイズが変更された場合も overflow 状態を再チェックし、必要に応じてtypeを切り替える
		splide.on('resized', () => {
			updateSplideType();
		});

		// isOverflow を下にカルーセルのtypeを切り替える
		function updateSplideType() {
			const shouldLoop = splide.isOverflow;
			const currentType = splide.options.type;
			const newType = shouldLoop ? 'loop' : 'slide';

			if (currentType !== newType) {
				splide.options = { type: newType };
				splide.mount();
			}
		}

		splide.mount();
		*/
	},
};

app.topics = {
    topicsItems: () => {
        const grid = document.querySelector('.js-topics-items');
        const msnry = new Masonry(grid, {
            itemSelector: '.p-topics__item',
            columnWidth: '.grid-sizer',
            gutter: 30,
            percentPosition: true
        });
  
        /* imagesLoaded(grid, () => {
            msnry.layout();
            msnry.on('layoutComplete', laidOutItems => {
                grid.classList.add('is-show');
            });
        });*/
      
        // layoutComplete を「先に」仕込む
        msnry.on('layoutComplete', laidOutItems => {
          grid.classList.add('is-show');
        });
    
        // 画像の読み込みが完了したら layout を実行
        imagesLoaded(grid, () => {
          msnry.layout();
        });
    },
}


//読み込み完了後に実行
document.addEventListener('DOMContentLoaded', () => {
	app.init();
});

/**
 * 現在時刻をサーバーから取得
 */
var illm = { common:{} };
illm.common.getServerDate = function() {
  const url = window.location.href;
  return fetch( url )
  .then(res => {
    if (!res.ok) throw new Error( 'fetch failed' );
    // レスポンスヘッダーから時刻を取得
    return new Date( res.headers.get('Date') );
  })
  .catch(error => {
    // エラー時はブラウザの現在時刻を返す
    return new Date();
  });
}

$(function() {

  // 現在時刻をサーバーから取得
  illm.common.getServerDate().then( date => {
    //「新作」アイコンの表示制御
    handleNewIconDisplay(date);
  });

});

/*
 * 「新作」アイコンの表示制御
 * @param date サーバー時間
 */
function handleNewIconDisplay(date){
  const currentTime = date.getTime();//1970年1月1日 00:00:00から経過した時間を秒単位に変換（UNIX時間）
  const hiddenClass = 'hidden';//非表示class名
  $( '.js-new-icon' ).each(function(){
    // 表示期限日を取得
    const newEndDate = new Date($(this).data().newDays);// 例：{newDays: '2025-12-31'}
    newEndDate.setHours(23, 59, 59, 999); // 表示期限は23時59分59秒999ミリ秒まで
    const newEndDateTime = newEndDate.getTime();//UNIX時間に変換
    if(isNaN(newEndDate)){
      return;
    }
    //期限日以内であれば、「新作」アイコンを表示
    if(currentTime <= newEndDateTime){
      $(this).removeClass(hiddenClass);
    }
  });
}